<template>
  <v-app light>
    <Alerts></Alerts>
    <v-content v-if="!loaded || textosLoading || checkingSession || comprobandoNumReservas">
      <v-container>
        <o-main-progress/>
      </v-container>
    </v-content>
    <template v-else>
      <NavigationDrawer/>
      <Toolbar/>
      <v-content>
        <v-slide-x-reverse-transition mode="out-in">
          <router-view/>
        </v-slide-x-reverse-transition>
      </v-content>
    </template>
  </v-app>
</template>

<script>
import NavigationDrawer from '@/components/NavigationDrawer'
import Toolbar from '@/components/Toolbar'
import Alerts from '@/components/Alerts'
import { mapGetters } from 'vuex'

export default {
  components: {
    NavigationDrawer,
    Toolbar,
    Alerts
  },
  data () {
    return {
    }
  },
  created () {
    this.changeTitle()
  },
  computed: {
    ...mapGetters({
      loaded: 'login/loaded',
      textosLoading: 'textos/loading',
      checkingSession: 'login/checkingSession',
      comprobandoNumReservas: 'login/comprobandoNumReservas'
    }),
    title () {
      return this.$t('general.misc.tituloApp')
    }
  },
  methods: {
    changeTitle () {
      document.title = this.title
    }
  },
  watch: {
    title () {
      this.changeTitle()
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue